import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsCurveHoldSizeM from './IconToolsCurveHold_size_m';

const props: CreateIconArguments = {
  l: IconToolsCurveHoldSizeM,
  m: IconToolsCurveHoldSizeM,
  s: IconToolsCurveHoldSizeM,
  xs: IconToolsCurveHoldSizeM,
  name: 'IconToolsCurveHold',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
